import React from "react";
import { Modal } from "react-bootstrap";
import { Formik, Form, Field, FieldArray } from "formik";
import * as Yup from "yup";

const FamilyModal = ({ show, onHide, onSubmit }) => {
  return (
    <Modal className="commn-modal-css" show={show} onHide={onHide} size="md">
      <Modal.Header className="border-0" closeButton></Modal.Header>
      <Modal.Body className="pt-0">
        <h2>Add family member</h2>
        {/* <p className="text-center text-muted">
          Once submitted, the family admin will be notified to approve your
          request.
        </p> */}
        <Formik
          initialValues={{
            names: [""],
            relation: "",
          }}
          validationSchema={Yup.object({
            names: Yup.array()
              .of(Yup.string().required("Name is required"))
              .min(1, "At least one name is required"),
            relation: Yup.string().required("Relation is required"),
          })}
          onSubmit={onSubmit}
        >
          {({ values, errors, touched }) => (
            <Form className="commn-form-set-profile">
              <FieldArray name="names">
                {({ push, remove }) => (
                  <div className="mb-3">
                    <label className="form-label">Names</label>
                    {values.names.map((_, index) => (
                      <div className="d-flex mb-2" key={index}>
                        <div className="flex-grow-1 me-0">
                          <Field
                            name={`names.${index}`}
                            className="form-control"
                            placeholder={`Enter name ${index + 1}`}
                          />
                          {errors.names?.[index] && touched.names?.[index] && (
                            <div className="text-danger small mt-1">
                              {errors.names[index]}
                            </div>
                          )}
                        </div>
                        {index > 0 && (
                          <button
                            type="button"
                            className="btn btn-danger"
                            onClick={() => remove(index)}
                          >
                            Remove
                          </button>
                        )}
                      </div>
                    ))}
                    <button
                      type="button"
                      className="btn btn-secondary mt-2"
                      onClick={() => push("")}
                    >
                      + Add Name
                    </button>
                  </div>
                )}
              </FieldArray>
              <div className="mb-3">
                <label className="form-label">Relation</label>
                <Field as="select" name="relation" className="form-select">
                  <option value="">Select</option>
                  <option value="Children">Children</option>
                  <option value="Father">Father</option>
                  <option value="Mother">Mother</option>
                  <option value="Sibling">Sibling</option>
                  <option value="Other">Other</option>
                </Field>
                {errors.relation && touched.relation && (
                  <div className="text-danger small mt-1">
                    {errors.relation}
                  </div>
                )}
              </div>
              <div className="d-flex justify-content-end gap-2 comnn-modal-action">
                <button type="button" className="outline" onClick={onHide}>
                  Close
                </button>
                <button type="submit" className="fill">
                  Submit
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};

export default FamilyModal;
